import {action, computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import Feature from "../../Feature";
import errorToast from "../../../components/toast/ErrorToast";
import successToast from "../../../components/toast/SuccessToast";

export default class LeadAssignmentQueueFeature extends Feature {
    constructor(application) {
        super(application);
        this._unassignedLeads = [];
        this._closersWorkloads = [];
        this._assignees = [];
        this._chosenResponsibleEmailsByLeadId = observable.map();

        makeObservable(this, {
            _unassignedLeads: observable,
            _closersWorkloads: observable,
            _assignees: observable,
            unassignedLeads: computed,
            closersWorkloads: computed,
            assignees: computed,
            highestActiveLeadsCount: computed,
            hasUnassignedLeads: computed,
            chooseResponsibleFor: action,
            _storeQueue: action,
        });
    }

    async load() {
        await this._loadQueue();
        this.finishLoading();
    }

    get unassignedLeads() {
        return this._unassignedLeads;
    }

    get closersWorkloads() {
        return this._closersWorkloads;
    }

    get assignees() {
        return this._assignees;
    }

    get hasUnassignedLeads() {
        return this._unassignedLeads.length > 0;
    }

    get highestActiveLeadsCount() {
        return Math.max(1, ...this._closersWorkloads.map((closerWorkload) => closerWorkload.activeLeadsCount));
    }

    chosenResponsibleEmailFor(lead) {
        return this._chosenResponsibleEmailsByLeadId.get(lead.id);
    }

    chooseResponsibleFor(lead, responsibleEmail) {
        this._chosenResponsibleEmailsByLeadId.set(lead.id, responsibleEmail);
    }

    async assignLead(lead) {
        const responsibleEmail = this.chosenResponsibleEmailFor(lead);
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: async () => {
                successToast('Lead asignado');
                await this._loadQueue();
            },
            handlesError: async (response) => {
                response.errors().forEach((error) => errorToast(error.text));
                await this._loadQueue();
            },
        });
        return this._application.apiClient().assignLead({leadId: lead.id, responsibleEmail}, responseHandler);
    }

    async _loadQueue() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => this._storeQueue(response),
            handlesError: () => errorToast('No se pudo obtener la cola de asignación de leads.'),
        });
        return this._application.apiClient().horecaLeadAssignmentQueue(responseHandler);
    }

    _storeQueue(response) {
        this._unassignedLeads = response.unassignedLeads();
        this._closersWorkloads = response.closersWorkloads();
        this._assignees = response.assignees();
        const assigner = this._assignees.find((assignee) => assignee.isTheAssigner);
        this._chosenResponsibleEmailsByLeadId.clear();
        this._unassignedLeads.forEach((lead) => this._chosenResponsibleEmailsByLeadId.set(lead.id, assigner.email));
    }
}
